import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c4d0f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-text-description-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 2,
  class: "nav-list"
}
const _hoisted_5 = { class: "nav-list-item" }

import {computed} from 'vue'
  import {useRoute, useRouter} from 'vue-router'
  import {useStore} from 'vuex'

  import IconButton from '@/components/inputs/IconButton.vue'

  import {t, hasT} from '@/lib/i18n'

  import {usePreloader} from '@/lib/preloader'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TextDescriptionView',
  setup(__props) {

  usePreloader()

  const store = useStore()
  const route = useRoute()
  const router = useRouter()

  const meta = computed(() => {
    return route.meta
  })

  const titleKey = computed(() => {
    return `${meta.value.contentKey}.title`
  })

  const contentKey = computed(() => {
    return `${meta.value.contentKey}.content`
  })

  const hasTitle = computed(() => {
    return hasT(store, titleKey.value)
  })

  const hasContent = computed(() => {
    return hasT(store, contentKey.value)
  })

  const titleText = computed(() => {
    if (hasTitle.value) {
      return t(store, titleKey.value)
    }

    return ''
  })

  const contentText = computed(() => {
    if (hasContent.value) {
      return t(store, contentKey.value)
    }

    return ''
  })

  const continueText = computed(() => t(store, 'continue'))

  const nextRoute = computed(() => meta.value.nextRoute)

  const showActions = computed(() => !!nextRoute.value)

  const onClick = () => {
    router.push(nextRoute.value)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(hasTitle))
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_unref(titleText)), 1))
      : _createCommentVNode("", true),
    (_unref(hasContent))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "content",
          innerHTML: _unref(contentText)
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_unref(showActions))
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(IconButton, {
              name: "submit",
              onClick: onClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(continueText)), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})